module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_16.09262dcc.jpg";